<template>
  <div class="protein-pack-update modal-content flex flex-col items-center gap-4 text-center overflow-hidden">
    <!-- Green arc header -->
    <div class="relative flex flex-col items-center w-full rounded-t-2xl h-[218px] overflow-hidden">
      <div class="flex-center absolute bg-green-300 w-[700px] h-[600px] -top-[400px] rounded-[50%] pointer-events-none overflow-hidden">
        <img
          v-if="upsell.product?.featured_image"
          :src="upsell.product.featured_image"
          :alt="upsell.product?.title"
          class="z-10 w-[273px] h-[276px] absolute -bottom-15 object-contain"
          width="273"
          height="276"
        >
      </div>
    </div>

    <div class="flex flex-col items-center gap-4 px-4 pb-4 sm:px-8 sm:pb-8 w-full text-center">
      <h2 class="text-3xl font-semibold -mt-4">
        Update Protein Pack
      </h2>

      <p class="text-neutral-900">
        Your bundle now contains {{ upsell.displayPackCount }} meals. Protein Pack must match your bundle size.
      </p>

      <p class="text-neutral-900">
        Please update to {{ upsell.displayPackCount }} packs or remove it from your order.
      </p>

      <div class="flex flex-col gap-2 w-full">
        <DisclosureButtonBase
          class="+large +green w-full"
          @click="handleUpdate"
        >
          Update to {{ upsell.displayPackCount }} Packs
          <template #disclosure>
            {{ upsell.priceDelta > 0 ? '+' : '' }}{{ formatCents(upsell.priceDelta) }}
          </template>
        </DisclosureButtonBase>

        <button
          class="button +border +large w-full"
          @click="handleRemove"
        >
          Remove Protein Packs
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DisclosureButton as DisclosureButtonBase } from '@oatsovernight/storybook'
import { useProteinPackUpsellStore } from '@/stores'
import { formatCents } from '@/utils/formatters'

const emit = defineEmits<{ close: [] }>()
const upsell = useProteinPackUpsellStore()

const handleUpdate = () => {
  upsell.confirmUpdate()
  emit('close')
}

const handleRemove = () => {
  upsell.remove()
  emit('close')
}
</script>

<style>
.modal-container:has(.protein-pack-update) {
  padding: 0 !important;
  max-width: 24rem !important;
}
.modal-container:has(.protein-pack-update) [aria-label="close"] {
  display: none;
}
</style>
